import { subDays } from "date-fns";

export const MAX_PRIOR_RANGE = 90;
export const MAX_TRANSACTIONS_DATE = new Date();
MAX_TRANSACTIONS_DATE.setHours(0, 0, 0, 0);
export const MIN_TRANSACTIONS_DATE = subDays(MAX_TRANSACTIONS_DATE, MAX_PRIOR_RANGE);
